import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { bookingFormActions } from 'angular/app/core/store/booking-form';
@Component({
  selector: 'app-booking-confirmation-page',
  template: `
    <div class="container">
      <img
        class="mx-auto mb-0 mt-12 w-36 md:mt-24 md:w-56"
        src="assets/img/confirmation-animated.gif"
      />
      <div class="mb-10 text-center text-lg font-bold">
        Votre demande nous est bien parvenue !
      </div>
      <div class="mx-auto grid grid-cols-1 gap-6 md:grid-cols-2 lg:w-4/5">
        <div class="flex gap-x-3">
          <div
            class="flex h-5 w-5 flex-none items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-white"
            >1</div
          >
          <div class="text-sm"
            >Nous avons bien réceptionné votre demande et l’examinerons dans les
            plus brefs délais. Un résumé de votre demande se trouve dans votre
            boîte e-mail.</div
          >
        </div>

        <div class="flex gap-x-3">
          <div
            class="flex h-5 w-5 flex-none items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-white"
            >2</div
          >
          <div class="text-sm"
            >Vous recevrez un nouvel e-mail lorsque votre demande de location
            aura été traitée avec des informations complémentaires.</div
          >
        </div>
      </div>
    </div>
  `,
  standalone: false,
})
export class BookingConfirmationPageComponent implements OnInit {
  constructor(private store: Store) {}

  ngOnInit() {
    this.store.dispatch(bookingFormActions.resetForm());
  }
}
